/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 企业认证
 */
import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';
export class EnterpriseController extends BasesController<any> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      details: EnumAPI.company_auth_token,
      // insert: EnumAPI.bffsvr_auth_submit,
      // update: EnumAPI.bffsvr_auth_submit,
      detailsParams: {
        valueGetter: (res) => {
          if (!lodash.isEmpty(res?.companyCoreResponse)) {
            return lodash.assign(res.companyCoreResponse, {
              _statusText: lodash.get(
                this.statusEnum,
                res.companyCoreResponse?.status,
                '未认证',
              ),
            });
          }
          return res;
        },
      },
    });
  }
  /**
   * 获取 认证状态
   * @des 状态对比 0:未认证 1:认证成功
   */
  getStatus() {
    return lodash.toString(this.entity.status);
  }
  /**
   * @des 状态对比 0:未认证 1:认证成功
   */
  eqStatus(status: '0' | '1') {
    return lodash.eq(this.getStatus(), status);
  }
  /**
   * @des 状态枚举
   */
  statusEnum = {
    '0': '未认证',
    '1': '已认证',
    // "2": '已认证',
    // "-1": '认证失败'
  };
  /**
   * @des 企业类型
   */
  companyType = [
    { label: '个体户', value: '1' },
    { label: '非个体', value: '2' },
  ];
  /**
   * @des 识别文件
   */
  identifyFile(key: 'picLicense' | 'picPermit' | 'picIdcard', urlStr) {
    return AjaxBasics.request(
      lodash.assign(
        lodash.get(
          {
            picLicense: EnumAPI.bffsvr_auth_ocrBusLicense,
            picPermit: EnumAPI.bffsvr_auth_ocrBusLicense,
            picIdcard: EnumAPI.bffsvr_auth_idCard,
          },
          key,
        ),
        { body: { urlStr } },
      ),
    );
  }
}
